import { render, staticRenderFns } from "./ColorChip.vue?vue&type=template&id=7765dcaa&scoped=true&"
import script from "./ColorChip.vue?vue&type=script&lang=js&"
export * from "./ColorChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765dcaa",
  null
  
)

export default component.exports